import React, { useEffect, useState } from "react"
import { Button, Form, Modal } from "react-bootstrap"

const initialValue = {id: null, Active: "true", FeatureName: "", FeatureDescription: "", PricePerMonth: ""}

const AddEditFeatureFlagModal = ({editFeatureFlag = null, show, onHide, onSave, onDelete = () => {}}) => {
    const [featureFlag, setFeatureFlag] = useState(initialValue)
    
    useEffect(()=>{

        if(editFeatureFlag) {
            setFeatureFlag({
                id: editFeatureFlag.id,
                Active: editFeatureFlag.Active,
                FeatureName: editFeatureFlag.FeatureName,
                FeatureDescription: editFeatureFlag.FeatureDescription || "",
                PricePerMonth: editFeatureFlag.PricePerMonth ? +editFeatureFlag.PricePerMonth : ""
            })
        } else {
            setFeatureFlag(initialValue)
        }
    }, [show])

    const handleSave = () => {
        onSave(featureFlag)
    }

    const handleDelete = () => {
        onDelete(featureFlag)
    }

    const handleChange = (e) => {
        setFeatureFlag({
            ...featureFlag,
            [e.target.name]: e.target.value
        })
    }

    const handleRadioButtonChange = e => {
        setFeatureFlag({
            ...featureFlag,
            [e.target.name]: e.target.value
        })
    }

    return <Modal show={show} onHide={onHide}>
        <Modal.Header>
            <Modal.Title>
                {editFeatureFlag ? "Edit feature flag #" + editFeatureFlag.id : "Create feature flag"}
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <Form>
            <Form.Group>
                <Form.Label>Status</Form.Label>
                <Form.Check
                    id="activeRadioOption"
                    type="radio"
                    name="Active"
                    label="Active"
                    value="true"
                    checked={featureFlag.Active === "true"}
                    onChange={handleRadioButtonChange}
                />
                <Form.Check
                    id="userRadioOption"
                    type="radio"
                    name="Active"
                    label="Inactive"
                    value="false"
                    checked={featureFlag.Active === "false"}
                    onChange={handleRadioButtonChange}
                />
            </Form.Group>
            <Form.Group>
                <Form.Label>Feature name</Form.Label>
                <Form.Control name="FeatureName" placeholder="Enter feature name" value={featureFlag.FeatureName} onChange={handleChange}/>
            </Form.Group>
            <Form.Group>
                <Form.Label>Feature description</Form.Label>
                <Form.Control name="FeatureDescription" placeholder="Enter feature description" value={featureFlag.FeatureDescription} onChange={handleChange} />
            </Form.Group>
            <Form.Group>
                <Form.Label>Price per month</Form.Label>
                <Form.Control type="number" name="PricePerMonth" placeholder="Enter price per month" value={featureFlag.PricePerMonth} onChange={handleChange}/>
            </Form.Group>
        </Form>
        </Modal.Body>
        <Modal.Footer>
            <Button variant="default" onClick={onHide}>Cancel</Button>
            {editFeatureFlag && <Button onClick={handleDelete} variant="danger">Delete</Button>}
            <Button onClick={handleSave}>Save</Button>
        </Modal.Footer>
    </Modal>
}

export default AddEditFeatureFlagModal